export enum ADD_CAMERA_ERROR {
  GENERIC = 'GENERIC',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  CODE_USED_OR_INVALID = 'CODE_USED_OR_INVALID',
  TIMEOUT_ERROR = 'TIMEOUT_ERROR',
}
